import { createBrowserRouter, Navigate, useSearchParams } from "react-router-dom";
import ResetPassword from "../components/auth/ResetPassword";
import ForgotPassword from "../components/auth/ForgotPassword";
import Verify from "../shades/Verify";
import Login from "../components/auth/Login";
import LoginMagicLink from "../components/auth/LoginMagicLink";
import LoginWithEmail from "../components/auth/LoginWithEmail";
import MagicLinkLogin from "../components/auth/MagicLinkLogin";
import TokenWaiting from "../components/auth/AuthTokenWaiting.jsx";
import AuthRedirect from "../components/auth/AuthRedirect";
import ActiveSubscription from "../components/auth/ActiveSubscription";
import MailVerify from "../components/mailVery";
import ResendEmail from "../components/auth/ResendEmail";
import Logout from "../components/auth/Logout";
import Extension from "../components/Extension";
import BucketInner from "../shades/cards/BucketInner";
import SubBucketInner from "../shades/cards/SubBucketInner";
import StarredCard from "../shades/cards/StarredCard";
import CardWithNotes from "../shades/cards/CardWithNotes";
import AllCards from "../shades/cards/AllCards";
import RecentCards from "../shades/cards/RecentCards";
import RecentEditCards from "../shades/cards/RecentEditCards";
import CardDetail from "../shades/cards/CardDetail";
import Gridview from "../shades/GridcompactView";
import CardListView from "../components/CardList/CardListView";
import GridProject from "../components/Projects/ProjectsGrid/ProjectsGrid";
import ProjectPreview from "../components/Projects/ProjectsPreview/ProjectsPreview";
import ProjectList from "../components/Projects/ProjectsList/ProjectsList";
import Tags from "../components/Tags/Tags";
import KindleList from "../components/Kindle/KindleList/KindleList";
import KindleDetail from "../components/Kindle/KindleDetail/KindleDetail";
import KindleSingleDetail from "../components/Kindle/KindleDetail/KindleSingleDetail";
import "../components/Dashboard/Dashboard";
import WhatIShared from "../components/WhatIShared/WhatIShared";
import EditProject from "../components/Projects/EditProject/EditProject";
import Popup from "../shades/cards/popup";
import Bookmarks from "../components/Bookmarks/Bookmarks";
import BookmarkDetail from "../components/BookmarkDetail/BookmarkDetail";
import BookmarksList from "../components/Bookmark List/bookmarklist";
import Files from "../components/Files/Files";
import FileDetail from "../components/Files/FileDetail";
import SliderPopup from "../shades/cards/Sliderpopup";
import PublicShared from "../components/PublicShare/Shared/Shared";
import PublicBucket from "../components/PublicBucket/PublicBucket/PublicBucket";
import EditCard from "../shades/cards/EditCard";
import EmailCampaign from "../components/EmailCampaign/EmailCampaign";
import PopupFinal from "../shades/cards/popupfinal.js";
import CardEdit from "../shades/cards/CardEdit";
import Settings from "../components/Settings/Settings";
import MyProfile from "../components/MyProfile/MyProfile";
import CreatePassword from "../components/auth/CreatePass";
import ShareWithMe from "../components/SharedWithMe/sharewithme";
import PricingPlans from "../components/PricingPlans/Plans/PricingPlans.js";
import UpgradePlan from "../components/MyProfile/Plan Details/UpgradePlan/UpgradePlan.js";
import RenewPlan from "../components/MyProfile/Plan Details/RenewPlan/RenewPlan.js";
import VisaPlan from "../components/MyProfile/Plan Details/VisaPlan/VisaPlan.js";
import PlanCheckout from "../components/PricingPlans/Plans/PlanCheckout.js";
import AddPayment from "../components/MyProfile/Plan Details/AddPayment/AddPayment.js";
import CancelPlan from "../components/MyProfile/Plan Details/CancelPlan/CancelPlan.js";
import TeamMembersPlan from "../components/MyProfile/Plan Details/TeamMembers/PlanTeamMembers.js";
import BillingInfo from "../components/MyProfile/Plan Details/BillingInfo/BillingInfo.js";
import ProfileAddPayment from "../components/MyProfile/Plan Details/MyProfile/ProfileAddPayment.js";
import UpdateBilling from "../components/MyProfile/Plan Details/UpdateBilling/UpdateBilling.js";
import InvoiceSummary from "../components/MyProfile/Invoice/InvoiceSummary/InvoiceSummary.js";
import UserPricing from "../components/NewPricingPlan/UserPricing/UserPricing.js";
import PaymentScreen from "../components/NewPricingPlan/PaymentScreen/PaymentScreen.js";
import SuccessScreen from "../components/NewPricingPlan/SuccessScreen/SuccessScreen.js";
import MySubscription from "../components/NewPricingPlan/MySubscription/MySubscription.js";
import UpdateBillingplan from "../components/NewPricingPlan/UpgradePlan/UpgradePlan.js";
import ManageTeam from "../components/NewPricingPlan/ManageTeam/ManageTeam.js";
import ManageInvite from "../components/NewPricingPlan/ManageInvite/ManageInvite.js";
import VerifyTokenExpiry from "../components/auth/verifyTokenExpiry";
import Expiry from "../components/auth/Expiry";
import NotFound from "../components/auth/NotFound";
import AiScreen from "../components/AiScreen/aiscreen.js";
import AdsList from "../components/Ads/AdsList";
import AdDetail from "../components/Ads/AdDetail";
import Brands from "../components/Brands/Brands";
import BrandDetail from "../components/Brands/BrandDetail";
import CreateBrand from "../components/Brands/CreateBrand";
import Audiences from "../components/Audiences/Audiences";
import AudienceDetail from "../components/Audiences/AudienceDetail";
import Competitors from "../components/Audiences/Competitors";
import "../components/Workflow/WorkflowBuilder";
import WorkflowCanvas from "../components/Workflow/WorkflowCanvas";
import Automation from "../components/EmailAutomation/Automation.jsx";
import CharacterLibrary from "../components/Characters/Characters.js";
import SpeakingCharacter from "../components/AiModule/SpeakingCharacter.js";
import VideoEditor from "../components/VideoEditor/VideoEditor.js";
import TalkingHead from "../components/AiModule/TalkingHead.js";
import AssetsLibraryPage from "../components/AssetsLibrary/AssetsLibraryPage";
import { AIMarketingApp } from "../components/Marketing/AIMarketingApp";
import App from "../App";
import SessionGate from "../components/auth/SessionGate";

function CardDetailRoute() {
  const [searchParams] = useSearchParams();
  return searchParams.get("card") === "file" ? <FileDetail /> : <CardDetail />;
}

export const Router = createBrowserRouter([
  {
    path: "/app",
    element: <SessionGate><App /></SessionGate>,
    children: [
      // {
      //   path: "/app/compact",
      //   element: <Bucket />,
      // },
      {
        path: "/app/buckets/:id",
        element: (
          <ActiveSubscription>
            <BucketInner />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/sub-buckets/:id",
        element: (
          <ActiveSubscription>
            <SubBucketInner />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/card",
        element: (
          <ActiveSubscription>
            <AllCards />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/public/bucket/:id",
        element: <AllCards />,
      },
      {
        path: "/app/card-detail/:id",
        element: (
          <ActiveSubscription>
            <CardDetailRoute />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/bookmark-detail/:id",
        element: (
          <ActiveSubscription>
            <BookmarkDetail />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/EditCard/:id",
        element: <EditCard />,
      },
      {
        path: "/app/CardEdit/:id",
        element: <CardEdit />,
      },
      {
        path: "/app/buckets",
        element: (
          <ActiveSubscription>
            <Gridview />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/cardlist/:id",
        element: <CardListView />,
      },
      {
        path: "/app/gridProject",
        element: <GridProject />,
      },
      {
        path: "/app/projectPreview",
        element: <ProjectPreview />,
      },
      {
        path: "/app/SharedWithMe",
        element: (
          <ActiveSubscription>
            <ShareWithMe />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/projectlist",
        element: <ProjectList />,
      },
      {
        path: "/app/tags",
        element: (
          <ActiveSubscription>
            <Tags />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/kindleList",
        element: (
          <ActiveSubscription>
            <KindleList />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/kindledetail/:id",
        element: (
          <ActiveSubscription>
            <KindleDetail />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/kindledetail/highlight/:id",
        element: (
          <ActiveSubscription>
            <KindleSingleDetail />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/marketing",
        element: (
          <ActiveSubscription>
            <AIMarketingApp />
          </ActiveSubscription>
        ),
      },
      // {
      //   path: "/app/dashboard",
      //   element: (
      //     <ActiveSubscription>
      //       <Dashboard />
      //     </ActiveSubscription>
      //   ),
      // },
      {
        path: "/app/whatishared",
        element: (
          <ActiveSubscription>
            <WhatIShared />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/starred",
        element: (
          <ActiveSubscription>
            <StarredCard />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/cardwithnotes",
        element: (
          <ActiveSubscription>
            <CardWithNotes />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/recent-saved",
        element: (
          <ActiveSubscription>
            <RecentCards />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/recent-edited",
        element: (
          <ActiveSubscription>
            <RecentEditCards />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/editProject",
        element: <EditProject />,
      },
      {
        path: "/app/popup",
        element: <Popup />,
      },
      {
        path: "/app/bookmarks",
        element: (
          <ActiveSubscription>
            <Bookmarks />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/bookmarklist",
        element: <BookmarksList />,
      },
      {
        path: "/app/files",
        element: (
          <ActiveSubscription>
            <Files />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/sliderpopup",
        element: <SliderPopup />,
      },
      // {
      //   path: '/app/publicshared',
      //   element: <PublicShared />
      // },
      {
        path: "/app/emailCampaign",
        element: <EmailCampaign />,
      },
      {
        path: "/app/popupFinal",
        element: <PopupFinal />,
      },
      {
        path: "/app/settings",
        element: (
          <ActiveSubscription>
            <Settings />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/myProfile",
        element: (
          <ActiveSubscription>
            <MyProfile />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/pricingPlans",
        element: <PricingPlans />,
      },
      {
        path: "/app/upgradePlan",
        element: <UpgradePlan />,
      },
      {
        path: "/app/renewPlan",
        element: <RenewPlan />,
      },
      {
        path: "/app/visaPlan",
        element: <VisaPlan />,
      },
      {
        path: "/app/planCheckout",
        element: <PlanCheckout />,
      },
      {
        path: "/app/addPayment",
        element: <AddPayment />,
      },
      {
        path: "/app/cancelPlan",
        element: <CancelPlan />,
      },
      {
        path: "/app/teamMembersPlan",
        element: <TeamMembersPlan />,
      },
      {
        path: "/app/billingInfo",
        element: <BillingInfo />,
      },
      {
        path: "/app/profileAddpayment",
        element: (
          <ActiveSubscription>
            <ProfileAddPayment />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/updateBilling",
        element: <UpdateBilling />,
      },
      {
        path: "/app/invoiceSummary/:id",
        element: <InvoiceSummary />,
      },
      {
        path: "/app/userPricing",
        element: <UserPricing />,
      },
      {
        path: "/app/paymentScreen",
        element: <PaymentScreen />,
      },
      {
        path: "/app/successScreen",
        element: (
          <ActiveSubscription>
            <SuccessScreen />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/mySubscription",
        element: (
          <ActiveSubscription>
            <MySubscription />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/updateBillingplan",
        element: (
          <ActiveSubscription>
            <UpdateBillingplan />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/manageInvite",
        element: (
          <ActiveSubscription>
            <ManageTeam />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/manageTeam",
        element: (
          <ActiveSubscription>
            <ManageInvite />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/aiscreen",
        element: (
          <ActiveSubscription>
            <AiScreen />
          </ActiveSubscription>
        ),
      },
      {
        path: "/app/ads",
        element: <AdsList />,
      },
      {
        path: "/app/automation",
        element: <Automation />,
      },
      {
        path: "/app/speaking-character",
        element: <SpeakingCharacter />,
      },
      {
        path: "/app/talking-head",
        element: <TalkingHead />,
      },
      {
        path: "/app/videoeditor",
        element: <VideoEditor />,
      },
      {
        path: "/app/assets-library",
        element: <AssetsLibraryPage />,
      },
      {
        path: "/app/characters",
        element: <CharacterLibrary />,
      },
      {
        path: "/app/brands",
        element: <Brands />,
      },
      {
        path: "/app/brands/:id",
        element: <BrandDetail />,
      },
      {
        path: "/app/brands/new",
        element: <CreateBrand />,
      },
      {
        path: "/app/audiences",
        element: <Audiences />,
      },
      {
        path: "/app/audiences/:id",
        element: <AudienceDetail />,
      },
      {
        path: "/app/audiences/:id/competitors",
        element: <Competitors />,
      },
      {
        path: "/app/ads/:id",
        element: <AdDetail />,
      },
      {
        path: "/app/workflow",
        element: <WorkflowCanvas />,
      },
    ],
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/login",
    element: (
      <AuthRedirect>
        <Login />
      </AuthRedirect>
    ),
  },
  // {
  //   path: "/signup",
  //   element: <AuthRedirect><SignUp /></AuthRedirect>,
  // },
  // {
  //   path: "/register",
  //   element: <AuthRedirect><SignUp /></AuthRedirect>,
  // },
  {
    path: "/invitationExpired",
    element: <VerifyTokenExpiry />,
  },
  {
    path: "/notFound",
    element: <NotFound />,
  },
  {
    path: "/expiry",
    element: <Expiry />,
  },
  {
    path: "/mailVerify/:id",
    element: <Verify />,
  },
  {
    path: "/token_waiting",
    element: (
      <AuthRedirect>
        <TokenWaiting />
      </AuthRedirect>
    ),
  },
  {
    path: "/loginmagic",
    element: <LoginMagicLink />,
  },
  {
    path: "/magic_link-login/:id",
    element: (
      <AuthRedirect>
        <MagicLinkLogin />
      </AuthRedirect>
    ),
  },
  {
    path: "/",
    element: (
      <AuthRedirect>
        <LoginWithEmail />
      </AuthRedirect>
    ),
  },
  {
    path: "/resetPassword/:id",
    element: (
      <AuthRedirect>
        <ResetPassword />
      </AuthRedirect>
    ),
  },
  {
    path: "/createPassword/:id",
    element: <CreatePassword />,
  },
  {
    path: "/verifyEmail/:id",
    element: <MailVerify />,
  },
  {
    path: "/forgotpassword",
    element: (
      <AuthRedirect>
        <ForgotPassword />
      </AuthRedirect>
    ),
  },
  {
    path: "/extension",
    element: <Extension />,
  },
  {
    path: "/resendEmail",
    element: (
      <AuthRedirect>
        <ResendEmail />
      </AuthRedirect>
    ),
  },
  {
    path: "/public/card/:id",
    element: <PublicShared />,
  },
  {
    path: "/public/bucket/:id",
    element: <PublicBucket />,
  },
  {
    path: "*",
    element: <Navigate to="/notFound" replace />,
  },
]);
